import React from "react";
import { Recycle, ArrowUpRight } from "lucide-react";

const ROTTAMAZIONI_URL = "https://romarottamazioni.com";

/**
 * Cross-promo section linking to the sister site Romarottamazioni.com.
 * Users who arrive here looking for scrap-car pickup get routed cleanly.
 */
export default function ScrapCrossLink() {
  return (
    <section
      id="rottamazione"
      data-testid="rottamazione-section"
      className="relative py-16 md:py-20 bg-white"
      aria-labelledby="rottamazione-title"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="relative overflow-hidden rounded-3xl border border-border bg-gradient-to-br from-white via-white to-brand-orange/5 p-6 sm:p-10 lg:p-14 shadow-sm">
          <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-brand-orange/10 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-navy/5 blur-3xl pointer-events-none" />

          <div className="relative grid md:grid-cols-12 gap-8 md:gap-10 items-center">
            <div className="md:col-span-8">
              <div className="inline-flex items-center gap-2 rounded-full bg-brand-orange/10 text-brand-orange px-3 py-1.5 text-xs sm:text-sm font-bold tracking-[0.18em] uppercase">
                <Recycle className="h-4 w-4" />
                Servizio partner
              </div>

              <h2
                id="rottamazione-title"
                data-testid="rottamazione-title"
                className="mt-4 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-navy tracking-tight"
              >
                Hai un'auto da <span className="text-brand-orange">rottamare</span>?
              </h2>

              <p
                data-testid="rottamazione-body"
                className="mt-4 text-muted-foreground text-base sm:text-lg leading-relaxed max-w-2xl"
              >
                Offriamo anche il <strong className="text-navy">ritiro di veicoli destinati alla rottamazione</strong> a Roma
                e provincia: auto vecchie, non funzionanti o senza revisione. Ritiro gratuito e pratiche gestite da noi
                sul sito partner <strong className="text-navy">Romarottamazioni.com</strong>.
              </p>
            </div>

            <div className="md:col-span-4 flex md:justify-end">
              <a
                href={ROTTAMAZIONI_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="rottamazione-cta"
                aria-label="Vai al sito Romarottamazioni.com (apre una nuova scheda)"
                className="group inline-flex w-full md:w-auto items-center justify-center gap-3 rounded-2xl bg-navy hover:bg-brand-orange text-white font-bold px-6 py-4 text-base sm:text-lg transition-all btn-glow-orange hover:-translate-y-0.5"
              >
                Vai a Romarottamazioni.com
                <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
